



















































































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {getChecking} from "@/modules/checking/services";
import {Checking} from "@/interfaces/entity/checking";
import {AuthStore} from "@/modules/auth/store";

@Component({
    name: "Checking"
})
export default class extends mixins(CommonMixin) {
    @Prop() readonly ladingCode!: string|undefined;
    @Prop({ default: [] }) readonly checkings!: any;

    get statusBillLading() {
        return this.getProp(this.checkings[this.checkings.length - 1], 'status', '');
    }

    get imageUrl() {
        return this.getProp(this.checkings[this.checkings.length - 1], 'billLading.imageUrls[0]', '');
    }

    get imageReportUrl() {
        return this.getProp(this.checkings[this.checkings.length - 1], 'billLading.imageReportUrls[0]', '');
    }

    get receiver() {
        return this.getProp(this.checkings[this.checkings.length - 1], 'billLading.receiver');
    }

    get noteDelivery() {
        return this.getProp(this.checkings[this.checkings.length - 1], 'note');
    }

    get timeReportDelivery() {
        return this.getProp(this.checkings[this.checkings.length - 1], 'billLading.dateOfDelivery');
    }

    get isAuthenticated() {
        return !!AuthStore.token
    }
}
